export const validateTotalAllocationRule = (investmentFundLimits, totalFundAllocation) => {
  return totalFundAllocation >= 0 && totalFundAllocation <= investmentFundLimits.maxTotalAllocation
}

export const validateMaxFundAllocationRule = (investmentFundLimits, fund) => {
  return fund.fundAllocation <= investmentFundLimits.maxTotalAllocation
}

export const validateMinFundAllocationRule = (investmentFundLimits, fund) => {
  return fund.fundAllocation >= investmentFundLimits.minFundAllocation
}
